'use strict';

var $scanBarcodeButton = $('.scan-barcode-btn');

var scanbarcode = {
    init: function () {
        /**
        * initialize scan barcode button and event handlers.
        * */
        if (typeof ___ENGAGE_NATIVE_PLAYER___ === 'function' || window.SHOW_BARCODE_BUTTON === true) {
            scanbarcode.show();
            // When the user clicks on the button, focus on the search bar at the top of the page
            $scanBarcodeButton.on('click', function () {
                scanbarcode.focusOnSearchBar();
            });
        }
    },
    focusOnSearchBar: function () {
        document.querySelector('.js-search-input').focus();
    },
    show: function () {
        $scanBarcodeButton.fadeIn(0).removeClass('d-none');
    }
};

module.exports = function () {
    scanbarcode.init();
};
